import React, { useEffect } from 'react';

import * as Sentry from '@sentry/react';

import { EnvsEnum } from '@utils/types';

import { useStore } from '@modules';

const isInitializedSentry = CONST.env !== EnvsEnum.local;

if (isInitializedSentry) {
  Sentry.init({
    dsn: 'https://6538ea7e18a342e391b392f4fd83b80c@o226908.ingest.sentry.io/5893969',
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: IS_DEV ? 1.0 : 0.2,
    environment: CONST.env,
    ignoreErrors: [
      'Non-Error exception captured',
      'Non-Error promise rejection captured',
      'Failed to load the JS script of the agent',
      'Network Error',
      /Object captured as promise rejection with keys:.*/,
      /Unable to load script https:\/\/beacon\.riskified\.com\?shop=www\.mercuryo\.io\&sid\=.*/,
    ],
    ignoreTransactions: [/^\/.*/],
    beforeBreadcrumb(breadcrumb) {
      return breadcrumb.category === 'ui.click' || breadcrumb.category === 'navigation'
        ? breadcrumb
        : null;
    },
  });
}

type TErrorBoundary = {
  children: React.ReactElement;
};

const ErrorBoundary: React.FC<TErrorBoundary> = ({ children }) => {
  const [{ user }] = useStore();
  const id = user.data?.uuid4;

  useEffect(() => {
    Sentry.setUser({ id });
  }, [id]);

  return <Sentry.ErrorBoundary>{children}</Sentry.ErrorBoundary>;
};

export default ErrorBoundary;
